import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import AuthLayout from '../components/AuthLayout';
import AuthError from '../components/AuthError';
import Field from '../components/Field';
import { useAuth } from '../auth/AuthContext';
import { emailRules } from '../lib/validation';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [serverError, setServerError] = useState('');
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: { email: '', password: '' } });

  const onSubmit = async ({ email, password }) => {
    setServerError('');
    try {
      await login(email, password);
      navigate('/');
    } catch (error) {
      setServerError(error.message || 'Login failed');
    }
  };

  return (
    <AuthLayout
      title="Welcome back"
      description="Log in to your Mini Notion account"
      footerText="Don't have an account?"
      footerLinkLabel="Register"
      footerLinkTo="/register"
    >
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="space-y-4 px-6 pb-4">
          <AuthError message={serverError} />

          <Field name="email" label="Email" error={errors.email?.message}>
            <Input
              type="email"
              placeholder="you@example.com"
              {...register('email', emailRules)}
            />
          </Field>

          <Field name="password" label="Password" error={errors.password?.message}>
            <Input
              type="password"
              placeholder="Your password"
              {...register('password', { required: 'Password is required' })}
            />
          </Field>

          <Button type="submit" className="w-full" disabled={isSubmitting}>
            {isSubmitting ? 'Logging in...' : 'Login'}
          </Button>
        </div>
      </form>
    </AuthLayout>
  );
}

export default Login;
